var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.7 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layers",
    transform: "translate(-1.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2757",
    "data-name": "Group 2757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M12,1.15a.85.85,0,0,1,.38.09l10,5a.85.85,0,0,1,0,1.521l-10,5a.85.85,0,0,1-.76,0l-10-5a.85.85,0,0,1,0-1.521l10-5A.85.85,0,0,1,12,1.15ZM20.1,7,12,2.95,3.9,7,12,11.05Z",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M12,22.85a.85.85,0,0,1-.38-.09l-10-5a.85.85,0,1,1,.76-1.521L12,21.05l9.62-4.81a.85.85,0,0,1,.76,1.521l-10,5A.85.85,0,0,1,12,22.85Z",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M12,17.85a.85.85,0,0,1-.38-.09l-10-5a.85.85,0,1,1,.76-1.521L12,16.05l9.62-4.81a.85.85,0,0,1,.76,1.521l-10,5A.85.85,0,0,1,12,17.85Z",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.e6836a9dd846665d358daa37c9718af9.svg";
export { ForwardRef as ReactComponent };